(function ($, Global) {
    var IMG_RESIZE_PATH = '/utils/imageresize';

    var ImageResize = function (obj) {
        this.file64 = obj.file64 || '';
        this.file = obj.file || '';
        this.width = obj.width ? parseInt(obj.width, 10) : 800;
        this.web = obj.web ? parseInt(obj.web, 10) : 1;
    }

    ImageResize.prototype.getSrc = function () {
        return IMG_RESIZE_PATH + '?x=' + this.width + '&web=' + this.web + (this.file64 !== '' ? '&file64=' + this.file64 : '&file=' + this.file)
    }

    Global.ImageResize = ImageResize;
}(jQuery, window));